import { render, staticRenderFns } from "./CustomerGenderAdd.vue?vue&type=template&id=186a22a4"
import script from "./CustomerGenderAdd.vue?vue&type=script&lang=js"
export * from "./CustomerGenderAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports